import React, { useState } from "react";
import Picture from "../../Picture";

import "./UnifiedFAQ.scss";

const DEFAULT_HELP_ICON = "/images/site/landing-pages/segmentos/help.svg";
const DEFAULT_ARROW_ICON = "/images/site/landing-pages/segmentos/keyboard-arrow-down.svg";

const UnifiedFAQ = ({
  title = "Perguntas frequentes",
  subtitle,
  faqItems = [],
  defaultOpenIndex = 0,
  className = "",
  titleId,
  titleTag: TitleTag = "h2",
  questionTag: QuestionTag = "span",
  helpIconSrc = DEFAULT_HELP_ICON,
  arrowIconSrc = DEFAULT_ARROW_ICON,
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultOpenIndex);
  const headingId = titleId || `faq-title-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

  if (!faqItems.length) {
    return null;
  }

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className={`unified-faq faq-section ${className}`.trim()} aria-labelledby={headingId}>
      <div className="faq-content">
        <div className="faq-header">
          <div className="faq-header__icon-wrap">
            <Picture src={helpIconSrc} alt="" aria-hidden="true" />
          </div>
          <div className="faq-header__text-col">
            <TitleTag className="faq-header__title" id={headingId}>{title}</TitleTag>
            {subtitle && <div className="faq-header__subtitle">{subtitle}</div>}
          </div>
        </div>

        <ul className="faq-accordion">
          {faqItems.map((item, index) => {
            const isOpen = activeIndex === index;
            const answerId = `${headingId}-answer-${index + 1}`;

            return (
              <li className={`faq-item ${isOpen ? "faq-item--open" : ""}`} key={item.question}>
                <button
                  className="faq-item__btn"
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => toggleItem(index)}
                >
                  <QuestionTag className="faq-item__question">{item.question}</QuestionTag>
                  <Picture className="faq-item__arrow" src={arrowIconSrc} alt="" aria-hidden="true" />
                </button>
                <div className="faq-item__answer" id={answerId}>
                  <div className="faq-item__answer-inner">
                    {typeof item.answer === "string" ? <p>{item.answer}</p> : item.answer}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default UnifiedFAQ;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/UnifiedFAQ/UnifiedFAQ.jsx